import ScannerWarningAlert from './ConfirmDriverModal/ScannerWarningAlert';
import { Option } from '@/components/inputs/AutocompleteInput';
import { Person as PersonIcon } from '@mui/icons-material';
import ConfirmationModal from '../ConfirmationModal';

interface ConfirmDriverModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  driver: Option | null;
  scannedCount: number;
}

const ConfirmDriverModal = ({
  open,
  onClose,
  onConfirm,
  driver,
  scannedCount,
}: ConfirmDriverModalProps) => {
  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title='Confirmar Conductor'
      icon={PersonIcon}
      description={
        <>
          ¿Está seguro de seleccionar a 
          <span className='font-black text-gray-800'> {driver?.label} </span>
          como el conductor para realizar la rendición?
          {scannedCount > 0 ? (
            <ScannerWarningAlert
              message={
                scannedCount === 1
                  ? 'Al cambiar de conductor se quitará el pedido escaneado y deberá escanearlo de nuevo.'
                  : `Al cambiar de conductor se quitarán los ${scannedCount} pedidos escaneados y deberá escanearlos de nuevo.`
              }
            />
          ) : (
            <ScannerWarningAlert />
          )}
        </>
      }
    />
  );
};

export default ConfirmDriverModal;
